import React from "react";
import { TextField } from "@vitalsource/vstui";
import { t } from "../../../core/translate";
import { Flex } from "../styles";
import { isValidPassword } from "../utils";

export default class Password extends React.PureComponent {
  render() {
    return (
      <Flex>
        <TextField
          required
          id="password-field"
          type="password"
          name="user[password]"
          label={t("base.password", "Password")}
          nativeFormControlRef={x => (this.password = x)}
          helperText={t("registration.valid-password", "Password Helper Text")}
          validate={() => {
            if (!isValidPassword(this.password.value)) {
              return t("registration.valid-password", "Password Helper Text");
            }
          }}
          rootProps={{
            style: {
              display: "inline-block",
              width: "calc(50% - 5px)"
            }
          }}
        />
        <TextField
          required
          id="confirm-password-field"
          type="password"
          name="user[confirm-password]"
          label={t("base.confirm-password", "Confirm Password")}
          rootProps={{
            style: {
              display: "inline-block",
              width: "calc(50% - 5px)"
            }
          }}
          nativeFormControlRef={x => (this.passwordConfirmation = x)}
          validate={() => {
            if (this.passwordConfirmation.value !== this.password.value) {
              return t("registration.pwd-no-match", "Passwords must match");
            }
          }}
        />
      </Flex>
    );
  }
}
